import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardOverviewTimelineRoute extends Route {
  @service store;

  queryParams = {
    status: {
      refreshModel: true,
    },
    sources: {
      refreshModel: true,
    },
    product_managers: {
      refreshModel: true,
    },
    themes: {
      refreshModel: true,
    },
    teams: {
      refreshModel: true,
    },
    show_grouping: {
      refreshModel: false,
    },
  };

  beforeModel() {
    const promises = [
      this.store.findAll('theme'),
      this.store.findAll('person'),
      this.store.findAll('team'),
    ];
    return Promise.all(promises).then(() => {});
  }

  relationshipPromises(initiative) {
    return [initiative.teams, initiative.belongsTo('bon').load()];
  }

  async model() {
    const results = (
      await this.store.query('initiative', { include: 'week' })
    ).slice();
    const promises = [];
    for (let i = 0; i < results.length; i++) {
      promises.push(this.relationshipPromises(results[i]));
    }
    const resolved_promises = await Promise.allSettled(promises.flat());
    for (let i = 0, j = 0; j < resolved_promises.length; i++, j += 2) {
      if (resolved_promises[j].status === 'fulfilled')
        results[i].teams_sync = resolved_promises[j].value.slice();
    }
    return results;
  }
}

export default instrumentRoutePerformance(
  PlanningDashboardOverviewTimelineRoute,
);
